// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangesCompanyDepartmentTemplate_wrapper__a4RV5","section":"ChangesCompanyDepartmentTemplate_section__Ysd4g","image":"ChangesCompanyDepartmentTemplate_image__StDdI"};